package top.wcpe.allincore.dsl.compiler.pipeline

import top.wcpe.allincore.dsl.compiler.api.ProjectTypeTable

/**
 * 编译选项。
 *
 * @property strict 严格模式：semantic 阶段产生 ERROR 时立即终止编译，不进入 codegen
 * @property placeholderRegistry PAPI 占位符注册表（M5-f 起）
 * @property knownComponentNames IDE 给单文件 pipeline 的"项目级已知 component 名"白名单。
 *   默认空集合。当 [ComponentExpanderPass] / [top.wcpe.allincore.dsl.compiler.semantic.ElementValidator]
 *   在 `Foo "id" { ... }` 这类调用上看到 `Foo` 命中白名单时,认为它是当前编译单元 *外* 声明
 *   的合法跨文件 component 引用，**跳过 E300 / E401 假阳性诊断**——但保留调用节点不展开，
 *   把跨文件展开的真实工作留给 [ScreenWithComponentsPipeline] 在多文件编译时统一处理。
 *   IDE 端通过 stub index 的 `AllinComponentNameIndex.getAllKeys` 收集后传入。
 * @property crossFileTypes 跨文件类型表（M10 Stage 4 引入）。
 *   IDE 端从 stub index 收集到当前项目的全部 data 类字段与 fun 签名后，把它打包成
 *   [ProjectTypeTable] 透传给 [top.wcpe.allincore.dsl.compiler.semantic.SemanticChecker]，
 *   让 [top.wcpe.allincore.dsl.compiler.semantic.NullSafetyChecker] 在 MemberAccess 上查
 *   data 字段名以触发 E669，让 [top.wcpe.allincore.dsl.compiler.type.TypeInferencer]
 *   反查跨文件类型避免类型推断退化为 Any。默认 [ProjectTypeTable.EMPTY]，向后兼容。
 * @property knownShaderPrograms 已由资源包 Shader Extension manifest 注册的静态 program 符号。
 */
data class CompileOptions(
    val strict: Boolean = true,
    val placeholderRegistry: PlaceholderRegistry? = null,
    val knownComponentNames: Set<String> = emptySet(),
    val crossFileTypes: ProjectTypeTable = ProjectTypeTable.EMPTY,
    /** 主题 token 严格校验：true 时未定义的 `theme.x` 引用报 ERROR（E796），false 时报 WARNING。默认关，保证零回归。 */
    val strictThemeTokens: Boolean = false,
    val knownShaderPrograms: Set<String> = emptySet(),
)
